const decorationItems = {
    // 1. BASIC TEXT DECORATIONS
    basic: [
      text => `【${text}】`,
      text => `『${text}』`,
      text => `〖${text}〗`,
      text => `〘${text}〙`,
      text => `〚${text}〛`,
      text => `〔${text}〕`,
      text => `〝${text}〞`,
      text => `〟${text}〟`,
      text => `«${text}»`,
      text => `‹${text}›`,
      text => `「${text}」`,
      text => `｢${text}｣`,
      text => `《${text}》`,
      text => `〈${text}〉`,
      text => `［${text}］`
    ],
  
    // 2. BOX DECORATIONS
    box: [
      // Thin border boxes
      text => {
        const horizontal = '─'.repeat(text.length + 2);
        return `┌${horizontal}┐\n│ ${text} │\n└${horizontal}┘`;
      },
      text => {
        const horizontal = '─'.repeat(text.length + 4);
        return `╭${horizontal}╮\n│  ${text}  │\n╰${horizontal}╯`;
      },
      
      // Double border boxes
      text => {
        const horizontal = '═'.repeat(text.length + 2);
        return `╔${horizontal}╗\n║ ${text} ║\n╚${horizontal}╝`;
      },
      text => {
        const horizontal = '═'.repeat(text.length + 4);
        return `╔${horizontal}╗\n║  ${text}  ║\n╚${horizontal}╝`;
      },
      
      // Thick border boxes
      text => {
        const horizontal = '━'.repeat(text.length + 2);
        return `┏${horizontal}┓\n┃ ${text} ┃\n┗${horizontal}┛`;
      },
      text => {
        const horizontal = '━'.repeat(text.length + 4);
        return `┏${horizontal}┓\n┃  ${text}  ┃\n┗${horizontal}┛`;
      },
      
      // Rounded corner boxes
      text => {
        const horizontal = '─'.repeat(text.length + 2);
        return `╭${horizontal}╮\n│ ${text} │\n╰${horizontal}╯`;
      },
      text => {
        const horizontal = '─'.repeat(text.length + 4);
        return `╭${horizontal}╮\n│  ${text}  │\n╰${horizontal}╯`;
      }
    ],
  
    // 3. ARROW DECORATIONS
    arrow: [
      text => `➤ ${text} ➤`,
      text => `➜ ${text} ➜`,
      text => `➔ ${text} ➔`,
      text => `➞ ${text} ➞`,
      text => `➟ ${text} ➟`,
      text => `➠ ${text} ➠`,
      text => `➢ ${text} ➢`,
      text => `➣ ${text} ➣`,
      text => `➥ ${text} ➥`,
      text => `➦ ${text} ➦`,
      text => `➧ ${text} ➧`,
      text => `➨ ${text} ➨`,
      text => `➩ ${text} ➩`,
      text => `➪ ${text} ➪`,
      text => `➫ ${text} ➫`,
      text => `➬ ${text} ➬`,
      text => `➭ ${text} ➭`,
      text => `➮ ${text} ➮`,
      text => `➯ ${text} ➯`,
      text => `➱ ${text} ➱`,
      text => `➲ ${text} ➲`,
      text => `➳ ${text} ➳`,
      text => `➵ ${text} ➵`,
      text => `➸ ${text} ➸`,
      text => `➹ ${text} ➹`,
      text => `➺ ${text} ➺`,
      text => `➻ ${text} ➻`,
      text => `➼ ${text} ➼`,
      text => `➽ ${text} ➽`,
      text => `➾ ${text} ➾`
    ],
  
    // 4. STAR DECORATIONS
    star: [
      text => `★ ${text} ★`,
      text => `☆ ${text} ☆`,
      text => `✧ ${text} ✧`,
      text => `✦ ${text} ✦`,
      text => `✩ ${text} ✩`,
      text => `✪ ${text} ✪`,
      text => `✫ ${text} ✫`,
      text => `✬ ${text} ✬`,
      text => `✭ ${text} ✭`,
      text => `✮ ${text} ✮`,
      text => `✯ ${text} ✯`,
      text => `✰ ${text} ✰`,
      text => `✵ ${text} ✵`,
      text => `✶ ${text} ✶`,
      text => `✷ ${text} ✷`,
      text => `✸ ${text} ✸`,
      text => `✹ ${text} ✹`,
      text => `✺ ${text} ✺`,
      text => `✻ ${text} ✻`,
      text => `✼ ${text} ✼`,
      text => `✽ ${text} ✽`,
      text => `✾ ${text} ✾`,
      text => `❀ ${text} ❀`,
      text => `❁ ${text} ❁`,
      text => `❂ ${text} ❂`,
      text => `❃ ${text} ❃`,
      text => `❄ ${text} ❄`,
      text => `❅ ${text} ❅`,
      text => `❆ ${text} ❆`,
      text => `❇ ${text} ❇`
    ],
  
    // 5. HEART DECORATIONS
    heart: [
      text => `♥ ${text} ♥`,
      text => `♡ ${text} ♡`,
      text => `❤ ${text} ❤`,
      text => `❥ ${text} ❥`,
      text => `❦ ${text} ❦`,
      text => `❧ ${text} ❧`,
      text => `💕 ${text} 💕`,
      text => `💖 ${text} 💖`,
      text => `💗 ${text} 💗`,
      text => `💘 ${text} 💘`,
      text => `💙 ${text} 💙`,
      text => `💚 ${text} 💚`,
      text => `💛 ${text} 💛`,
      text => `💜 ${text} 💜`,
      text => `💝 ${text} 💝`
    ],
  
    // 6. MUSIC DECORATIONS
    music: [
      text => `♫ ${text} ♫`,
      text => `♬ ${text} ♬`,
      text => `♪ ${text} ♪`,
      text => `♩ ${text} ♩`,
      text => `♭ ${text} ♭`,
      text => `♮ ${text} ♮`,
      text => `♯ ${text} ♯`,
      text => `🎵 ${text} 🎵`,
      text => `🎶 ${text} 🎶`,
      text => `🎼 ${text} 🎼`
    ],
  
    // 7. FLOWER DECORATIONS
    flower: [
      text => `✿ ${text} ✿`,
      text => `❀ ${text} ❀`,
      text => `❁ ${text} ❁`,
      text => `🌸 ${text} 🌸`,
      text => `🌺 ${text} 🌺`,
      text => `🌻 ${text} 🌻`,
      text => `🌼 ${text} 🌼`,
      text => `🌷 ${text} 🌷`,
      text => `🌹 ${text} 🌹`,
      text => `💐 ${text} 💐`
    ],
  
    // 8. WEATHER DECORATIONS
    weather: [
      text => `☀️ ${text} ☀️`,
      text => `☁️ ${text} ☁️`,
      text => `☔ ${text} ☔`,
      text => `❄️ ${text} ❄️`,
      text => `⛄ ${text} ⛄`,
      text => `⚡ ${text} ⚡`,
      text => `🌀 ${text} 🌀`,
      text => `🌈 ${text} 🌈`,
      text => `🌊 ${text} 🌊`,
      text => `🌪️ ${text} 🌪️`
    ],
  
    // 9. ANIMAL DECORATIONS
    animal: [
      text => `🐶 ${text} 🐶`,
      text => `🐱 ${text} 🐱`,
      text => `🐭 ${text} 🐭`,
      text => `🐹 ${text} 🐹`,
      text => `🐰 ${text} 🐰`,
      text => `🦊 ${text} 🦊`,
      text => `🐻 ${text} 🐻`,
      text => `🐼 ${text} 🐼`,
      text => `🐨 ${text} 🐨`,
      text => `🐯 ${text} 🐯`
    ],
  
    // 10. FOOD DECORATIONS
    food: [
      text => `🍎 ${text} 🍎`,
      text => `🍐 ${text} 🍐`,
      text => `🍊 ${text} 🍊`,
      text => `🍋 ${text} 🍋`,
      text => `🍌 ${text} 🍌`,
      text => `🍉 ${text} 🍉`,
      text => `🍇 ${text} 🍇`,
      text => `🍓 ${text} 🍓`,
      text => `🍈 ${text} 🍈`,
      text => `🍒 ${text} 🍒`
    ],
  
    // 11. HOLIDAY DECORATIONS
    holiday: [
      text => `🎄 ${text} 🎄`,
      text => `🎅 ${text} 🎅`,
      text => `🤶 ${text} 🤶`,
      text => `🎁 ${text} 🎁`,
      text => `🎊 ${text} 🎊`,
      text => `🎉 ${text} 🎉`,
      text => `🎈 ${text} 🎈`,
      text => `🎆 ${text} 🎆`,
      text => `🎇 ${text} 🎇`,
      text => `✨ ${text} ✨`
    ],
  
    // 12. TECHNOLOGY DECORATIONS
    tech: [
      text => `📱 ${text} 📱`,
      text => `💻 ${text} 💻`,
      text => `⌨️ ${text} ⌨️`,
      text => `🖥️ ${text} 🖥️`,
      text => `🖨️ ${text} 🖨️`,
      text => `🖱️ ${text} 🖱️`,
      text => `💽 ${text} 💽`,
      text => `💾 ${text} 💾`,
      text => `💿 ${text} 💿`,
      text => `📀 ${text} 📀`
    ],
  
    // 13. TRANSPORT DECORATIONS
    transport: [
      text => `🚗 ${text} 🚗`,
      text => `🚕 ${text} 🚕`,
      text => `🚙 ${text} 🚙`,
      text => `🚌 ${text} 🚌`,
      text => `🚎 ${text} 🚎`,
      text => `🏎️ ${text} 🏎️`,
      text => `🚓 ${text} 🚓`,
      text => `🚑 ${text} 🚑`,
      text => `🚒 ${text} 🚒`,
      text => `🚐 ${text} 🚐`
    ],
  
    // 14. SPORT DECORATIONS
    sport: [
      text => `⚽ ${text} ⚽`,
      text => `🏀 ${text} 🏀`,
      text => `🏈 ${text} 🏈`,
      text => `⚾ ${text} ⚾`,
      text => `🥎 ${text} 🥎`,
      text => `🎾 ${text} 🎾`,
      text => `🏐 ${text} 🏐`,
      text => `🏉 ${text} 🏉`,
      text => `🥏 ${text} 🥏`,
      text => `🎱 ${text} 🎱`
    ],
  
    // 15. GAME DECORATIONS
    game: [
      text => `🎮 ${text} 🎮`,
      text => `🕹️ ${text} 🕹️`,
      text => `🎲 ${text} 🎲`,
      text => `♟️ ${text} ♟️`,
      text => `🎯 ${text} 🎯`,
      text => `🎳 ${text} 🎳`,
      text => `🎰 ${text} 🎰`,
      text => `🎴 ${text} 🎴`,
      text => `🀄 ${text} 🀄`,
      text => `🃏 ${text} 🃏`
    ]
  };
  
  export default decorationItems;